import "./PublicOfferPage.css";
import { useState } from "react";
import { getReviews } from "../utils/api";
import ReviewsCarousel from "../components/ReviewsCarousel";
import SEO from "../components/SEO";

export default function PublicOfferPage() {
  const [reviews, setReviews] = useState([]);
  getReviews().then((r) => setReviews(r.data.data));
  return (
    <div className="offer-page page-enter">
      <SEO
        title="Публічна оферта"
        description="Умови договору, політики сайту та юридична інформація"
        url="https://zori.place/public-offer"
      />
      <header className="offer-hero">
        <div className="container">
          <h1 className="section-title">Публічна оферта</h1>
          <p className="section-subtitle">Умови договору, політики сайту та юридична інформація</p>
        </div>
      </header>

      <main className="offer-content">
        <div className="container">
          <article className="offer-doc">
            {/* 1 */}
            <section className="offer-section">
	      <h2>1. ПУБЛІЧНА ОФЕРТА</h2>
              <h3>1. Загальні положення</h3>
              <p>
                Ця публічна оферта є офіційною пропозицією ФОП Давиденко Олександра Миколаївна (далі
                — «Продавець») укласти договір купівлі-продажу товарів дистанційним способом.
                Оформлення замовлення на сайті https://zori.place означає повну згоду Покупця з
                умовами цієї Оферти.
              </p>

              <h3>2. Дані Продавця</h3>
              <div className="offer-block">
                <p>ФОП: Давиденко Олександра Миколаївна</p>
                <p>ІПН: 2867006367</p>
                <p>Адреса: Україна, м. Дніпро, 49000, вул. Рибалкова, буд. 35</p>
                <p>Email: zori.place1@gmail.com</p>
                <p>Телефон/Viber/Telegram: +380933406560</p>
                <p>Instagram: @zori.place.stickers</p>
                <p>Сайт: https://zori.place</p>
                <p>IBAN: UA563220010000026007350020921</p>
              </div>

              <h3>3. Предмет договору</h3>
              <p>Продавець здійснює продаж:</p>
              <ul>
                <li>декоративних наліпок</li>
                <li>дерев’яного декору</li>
                <li>постерів</li>
                <li>фотошпалер</li>
              </ul>
              <p>Товари виготовляються як готові, так і індивідуальні під замовлення.</p>

              <h3>4. Оформлення та виготовлення замовлення</h3>
              <ul>
                <li>передоплата 200 грн або 100% вартості (для стандартних товарів)</li>
                <li>для індивідуальних замовлень — 50% передоплати від погодженої суми</li>
                <li>строк виготовлення: 1–3 робочі дні</li>
              </ul>
              <p>
                У разі відмови від замовлення після запуску у виробництво передоплата не
                повертається.
              </p>

              <h3>5. Ціни</h3>
              <ul>
                <li>Ціни на стандартні товари фіксовані</li>
                <li>Ціни на індивідуальні замовлення узгоджуються окремо</li>
              </ul>

              <h3>6. Доставка</h3>
              <ul>
                <li>Нова Пошта</li>
                <li>Укрпошта</li>
                <li>міжнародна доставка (Укрпошта, Nova Global)</li>
              </ul>
              <ul>
                <li>безкоштовно від 3500 грн</li>
                <li>менші замовлення — за тарифами перевізника</li>
              </ul>
              <p>Строки доставки залежать від служби доставки.</p>

              <h3>7. Оплата</h3>
              <ul>
                <li>еквайринг Monobank</li>
                <li>оплата на реквізити ФОП</li>
                <li>післяплата</li>
              </ul>

              <h3>8. Повернення та обмін</h3>
              <p>Повернення можливе протягом 14 днів за умови збереження товарного вигляду.</p>

              <p>
                <strong>Не підлягають поверненню:</strong>
              </p>
              <ul>
                <li>індивідуальні замовлення</li>
                <li>фотошпалери (окрім виробничого браку)</li>
              </ul>

              <p>
                <strong>У разі браку:</strong>
              </p>
              <ul>
                <li>товар передруковується або замінюється за рахунок Продавця</li>
                <li>якщо пошкодження сталося з вини перевізника — складається акт</li>
              </ul>

              <p>Вартість повернення оплачує Покупець (крім випадків браку).</p>

              <h3>9. Відповідальність сторін</h3>
              <p>
                Продавець не несе відповідальності за неправильний монтаж/поклейку товарів Покупцем.
              </p>

              <h3>10. Особливості товару</h3>
              <ul>
                <li>кольори можуть відрізнятися через екран та друк</li>
                <li>розміри можуть мати незначні відхилення</li>
                <li>покупець сам перевіряє тексти в персоналізованих замовленнях</li>
              </ul>

              <h3>11. Авторські права</h3>
              <p>Усі дизайни, фото та матеріали сайту є власністю Продавця.</p>
              <ul>
                <li>заборонено копіювання дизайнів</li>
                <li>перепродаж макетів</li>
                <li>використання фото без дозволу</li>
              </ul>
            </section>

            {/* PRIVACY */}
            <section className="offer-section">
              <h2>2. PRIVACY POLICY (ПОЛІТИКА КОНФІДЕНЦІЙНОСТІ)</h2>
              <p>Сайт https://zori.place збирає персональні дані виключно для:</p>
              <ul>
                <li>оформлення замовлень</li>
                <li>зв’язку з клієнтом</li>
                <li>доставки товарів</li>
              </ul>

              <p>
                <strong>Збираються дані:</strong>
              </p>
              <ul>
                <li>ім’я</li>
                <li>телефон</li>
                <li>email</li>
                <li>адреса доставки</li>
              </ul>

              <p>Дані не передаються третім особам, окрім служб доставки.</p>

              <p>
                <strong>Сайт не використовує:</strong>
              </p>
              <ul>
                <li>cookies аналітики</li>
                <li>Google Analytics</li>
                <li>Meta Pixel</li>
              </ul>
            </section>

            {/* DELIVERY */}
            <section className="offer-section">
              <h2>3. ПОЛІТИКА ДОСТАВКИ</h2>
              <ul>
                <li>Нова Пошта</li>
                <li>Укрпошта</li>
                <li>міжнародна доставка (Укрпошта / Nova Global)</li>
              </ul>
              <p>Безкоштовна доставка від 3500 грн.</p>
              <p>Строки залежать від перевізника.</p>
              <p>Відповідальність за строки доставки несе перевізник.</p>
            </section>

            {/* RETURNS */}
            <section className="offer-section">
              <h2>4. ПОЛІТИКА ПОВЕРНЕННЯ</h2>
              <p>Повернення можливе протягом 14 днів за умови збереження товарного вигляду.</p>

              <p>
                <strong>Не підлягають поверненню:</strong>
              </p>
              <ul>
                <li>індивідуальні замовлення</li>
                <li>фотошпалери (крім браку)</li>
              </ul>

              <p>У разі браку — заміна або передрук за рахунок продавця.</p>
              <p>Передоплата не повертається після запуску у виробництво.</p>
            </section>

            {/* COOKIE */}
            <section className="offer-section">
              <h2>5. COOKIE POLICY</h2>
              <p>Сайт не використовує cookies для аналітики або реклами.</p>
              <p>
                Можуть використовуватись лише технічні cookies для роботи сайту та оформлення
                замовлень.
              </p>
            </section>
          </article>
          {/* Reviews Section */}
          {reviews.length > 0 && (
            <section className="home-reviews">
              <div className="container">
                <h2 className="home-section-label center">Відгуки клієнтів</h2>
                <ReviewsCarousel reviews={reviews} />
              </div>
            </section>
          )}
        </div>
      </main>
    </div>
  );
}
